import { provideHttpClient, withInterceptors, withNoXsrfProtection } from '@angular/common/http';
import { ENVIRONMENT_INITIALIZER, EnvironmentProviders, inject, Provider } from '@angular/core';
import { ApiRequestInterceptor } from "./api-request.interceptor";
import { AuthService } from "../auth/auth.service";

/**
 * Provider that enables URL replacement via http interceptor when configured in app.config.ts
 * This is new in Angular 15+
 * See: https://www.angulararchitects.io/en/blog/the-refurbished-httpclient-in-angular-15-standalone-apis-and-functional-interceptors/
 */
export const provideApiBaseUrl = (): Array<Provider | EnvironmentProviders> =>
{
    return [
        provideHttpClient(
            withNoXsrfProtection(), // temp hack, remove in PRODUCTION environment.
            withInterceptors([ApiRequestInterceptor])),
        {
            provide : ENVIRONMENT_INITIALIZER,
            useValue: () => inject(AuthService),
            multi   : true,
        },
    ];
};
